
export enum ClaimPartyTypeCd {
	CLAIMANT = 'Claimant',
	PAYEE = 'Payee'}

